import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Flex } from "@UI/Components/Flex/Flex";
import { Text } from "@UI/Components/Text/Text";
import { Icon } from "@UI/Components/Icon/Icon";
import { CircleInfo } from "@UI/Components/Icons/CircleInfo";
import messages from "./messages";

interface Props {
  context: "repeat_rate" | "realisation_rate" | "selection_rate";
  remainingEffort: number | null | undefined;
}

const MESSAGE_BY_CONTEXT = {
  repeat_rate: messages.remainingEffortRepeatRate,
  realisation_rate: messages.remainingEffortRealisationRate,
  selection_rate: messages.remainingEffortSelectionRate,
};

const bold = (...chunks: React.ReactNode[]) => (
  <Text as="span" fontWeight={700}>
    {chunks}
  </Text>
);

export const RemainingEffortNotice = ({ context, remainingEffort }: Props) => {
  if (!remainingEffort || remainingEffort <= 0) return null;

  return (
    <Flex
      bg="#E6F5FF"
      borderRadius="lg"
      p={4}
      gap={3}
      alignItems="flex-start"
      mb={{ base: 4, md: 6 }}
    >
      <Icon as={CircleInfo} boxSize="18px" color="#0098FE" flexShrink={0} mt="2px" />
      <Text fontSize={{ base: "sm", md: "md" }} color="#0098FE" mb={0}>
        <FormattedMessage
          {...MESSAGE_BY_CONTEXT[context]}
          values={{ count: remainingEffort, bold }}
        />
      </Text>
    </Flex>
  );
};
